module.exports = __webpack_public_path__ + "static/media/Mail.aa05fcca.svg";